(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgTransitionNotifier', sgTransitionNotifier);

  sgTransitionNotifier.$inject = [];

  function sgTransitionNotifier () {

    return {
      templateUrl: 'app-legacy/components/sg-transition-notifier/sg-transition-notifier.html',
      restrict: 'E',
      replace: true,
      controller: 'sgTransitionNotifierCtrl',
      controllerAs: 'transitionCtrl'
    };
  };


})();
